/* eslint-disable no-shadow */

import System from '../../api/system';

// initial state
const state = {
  title: 'Bionic Metrics',
  hasSubheader: false,
  serverUp: false,
  serverVersion: null,
  appVersion: process.env.APP_VERSION,
  breadcrumbs: null,
  savingStatus: null, // null, 'SAVING', 'SAVED'
  focus: 0,
  reload: 0 // incremented if we need to destory/re-create pages dropped into router-view
};

// getters - all receive state as first argument
const getters = {
  getSavingStatus: (state) => state.savingStatus,
  getReload: (state) => state.reload,
  getTitle: (state) => state.title,
  getAppVersion: (state) => state.appVersion,
  getServerVersion: (state) => state.serverVersion,
  getServerUp: (state) => state.serverUp,
  getHasSubheader: (state) => state.hasSubheader,
  getBreadcrumbs: (state) => state.breadcrumbs,
  getFocus: (state) => state.focus
};

// actions
const actions = {
  async getServerVersion({commit}) {
    const version = await System.version();
    commit('setServerVersion', version.version);
  },
  async getServerUp({commit}) {
    const up = await System.up();
    commit('setServerVersion', !!up);
  }
};

// mutations
const mutations = {
  reloadRouter(state) {
    state.reload++;
  },
  setSavingStatus(state, savingStatus) {
    state.savingStatus = savingStatus;
  },
  setServerVersion(state, version) {
    state.serverVersion = version;
  },
  setServerUp(state, up) {
    state.serverUp = up;
  },
  setTitle(state, title) {
    state.title = title;
  },
  setHasSubheader(state, hasSubheader) {
    state.hasSubheader = hasSubheader;
  },
  setBreadcrumb(state, breadcrumbs) {
    state.breadcrumbs = breadcrumbs;
  },
  setFocus(state) {
    state.focus += 1;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
